import { __assign, __read, __spread } from "tslib";
export function isSubschemaConfig(value) {
    return Boolean(value === null || value === void 0 ? void 0 : value.schema);
}
export function cloneSubschemaConfig(subschemaConfig) {
    var newSubschemaConfig = __assign(__assign({}, subschemaConfig), { transforms: subschemaConfig.transforms != null ? __spread(subschemaConfig.transforms) : undefined });
    if (newSubschemaConfig.merge != null) {
        newSubschemaConfig.merge = __assign({}, subschemaConfig.merge);
        Object.keys(newSubschemaConfig.merge).forEach(function (typeName) {
            newSubschemaConfig.merge[typeName] = __assign({}, subschemaConfig.merge[typeName]);
            var fields = newSubschemaConfig.merge[typeName].fields;
            if (fields != null) {
                Object.keys(fields).forEach(function (fieldName) {
                    fields[fieldName] = __assign({}, fields[fieldName]);
                });
            }
            var computedFields = newSubschemaConfig.merge[typeName].computedFields;
            if (computedFields != null) {
                Object.keys(computedFields).forEach(function (fieldName) {
                    computedFields[fieldName] = __assign({}, computedFields[fieldName]);
                });
            }
        });
    }
    return newSubschemaConfig;
}
//# sourceMappingURL=subschemaConfig.js.map